import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/onelinq.webp';
import screenshot_target from '../../../images/letterfunnel/pragneshgandhi.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Pragnesh Gandhi"
      firstname="Pragnesh"
      companyname="OneLinQ"
      competition="Cobase en Kyriba"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/pragneshgandhi.js